import about from "@/assets/jerry.webp";

const credentials = [
  "Licensed Professional Counselor (LPC), Minnesota",
  "M.S., Walden University",
  "Former child abuse coordinator",
  "Union contract negotiator (city & union sides)",
  "12 years teaching religion; college instructor on relationships",
  "Experience with paranoid schizophrenia, bipolar & major depression in residential care",
];

export function About() {
  return (
    <section id="about" className="relative py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-[0.9fr_1.1fr]">
        <div className="reveal relative">
          <div className="grain relative overflow-hidden rounded-3xl">
            <img
              src={about}
              alt="Portrait of Jerome 'Jerry' Bottelberghe, Licensed Professional Counselor in Minnesota"
              width={404}
              height={510}
              sizes="(min-width: 1024px) 40vw, 100vw"
              loading="lazy"
              decoding="async"
              className="aspect-[4/5] w-full object-cover object-top"
            />
          </div>
          <div className="absolute -bottom-6 -right-4 rounded-2xl border border-border bg-card px-5 py-4 shadow-[var(--shadow-soft)]">
            <div className="font-display text-2xl text-sage-deep">Jerome "Jerry" Bottelberghe</div>
            <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground">
              LPC · Minnesota
            </div>
          </div>
        </div>

        <div className="reveal">
          <p className="text-xs font-medium uppercase tracking-[0.22em] text-sage-deep">
            About Jerry
          </p>
          <h2 className="mt-4 font-display text-4xl font-medium tracking-tight text-balance sm:text-5xl">
            A practice built on listening &mdash; and the experience to back it up.
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-foreground/80">
            Jerry's career has spanned the rooms most people only see from the outside: residential
            care for serious mental illness, child welfare coordination, union negotiation, and
            twelve years teaching. Today he runs a private practice serving individuals, students,
            and couples — with a deep respect for the LGBTQ+ community and the families navigating
            the family court system.
          </p>

          <ul className="mt-8 grid gap-3 sm:grid-cols-2">
            {credentials.map((c) => (
              <li
                key={c}
                className="flex items-start gap-3 rounded-xl border border-border/60 bg-card/60 p-4 text-sm leading-snug"
              >
                <span
                  aria-hidden
                  className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage-soft text-sage-deep"
                >
                  ✓
                </span>
                {c}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
